import { createContext } from 'react';

// Portal target for page toolbars; null outside a Page or before the slot mounts.
export const PageToolbarSlotContext = createContext<HTMLElement | null>(null);
